<div class="banner-container" [ngClass]="{ mobile: isMobile() }">
  <div class="banner-content">
    <h1>{{ 'Regisztráció kutyásoknak' | translate }}</h1>
  </div>
</div>

<div class="page-container" [ngClass]="{ mobile: isMobile() }">
  <div class="page-content">
    <form [formGroup]="registerForm" (ngSubmit)="register()">
      <section class="max-width" formGroupName="values">
        <h2 class="no-top-margin">{{ 'Profil adatok' | translate }}</h2>
        <h3 class="required">{{ 'E-mail cím' | translate }}</h3>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="email" type="email" />
          <mat-error
            *ngIf="
              registerForm.controls.values.controls.email.hasError('required')
            ">
            {{ 'E-mail cím megadása kötelező!' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              registerForm.controls.values.controls.email.hasError('email')
            ">
            {{ 'Kérjük valódi E-mail címet írj be!' | translate }}
          </mat-error>
        </mat-form-field>
        <h3 class="required">{{ 'E-mail cím megerősítés' | translate }}</h3>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="email2" type="email" />
          <mat-error
            *ngIf="
              registerForm.controls.values.controls.email2.hasError('required')
            ">
            {{ 'E-mail cím megadása kötelező!' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              registerForm.controls.values.controls.email2.hasError('email')
            ">
            {{ 'Kérjük valódi E-mail címet írj be!' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              registerForm.controls.values.controls.email2.hasError(
                'controlEquals'
              )
            ">
            {{ 'E-mail címek nem megegyezőek!' | translate }}
          </mat-error>
        </mat-form-field>
        <h3 class="required">{{ 'Jelszó' | translate }}</h3>
        <div class="half-input-section">
          <div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input
                matInput
                placeholder="********"
                formControlName="password"
                type="password" />
              <mat-error
                *ngIf="
                  registerForm.controls.values.controls.password.hasError(
                    'required'
                  )
                ">
                {{ 'Jelszó megadása kötelező!' | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  registerForm.controls.values.controls.password.hasError(
                    'passwordLength'
                  )
                ">
                {{ 'Jelszó legyen legalább 8 karakter!' | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  registerForm.controls.values.controls.password.hasError(
                    'passwordHasNumber'
                  )
                ">
                {{ 'A jelszó tartalmazzon legalább egy számot!' | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  registerForm.controls.values.controls.password.hasError(
                    'passwordHasLowercaseUppercase'
                  )
                ">
                {{
                  'A jelszó tartalmazzon kis és nagybetűket egyaránt!'
                    | translate
                }}
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="!isMobile()">
            <img
              id="info-icon"
              src="ui/info-icon-2.svg"
              width="25"
              height="25"
              alt="Info icon"
              [matTooltip]="
                'Jelszavad legalább 8 karakter legyen, tartalmazzon kis- és nagybetűket, valamint számot'
                  | translate
              "
              aria-label="Icon that displays password strength guidelines."
              matTooltipClass="globodog-tooltip"
              matTooltipPosition="right" />
          </div>
        </div>
        <div *ngIf="isMobile()">
          {{
            'Jelszavad legalább 8 karakter legyen, tartalmazzon kis- és nagybetűket, valamint számot'
              | translate
          }}
        </div>
        <h3 class="required">{{ 'Jelszó megerősítése' | translate }}</h3>
        <div class="half-input-section">
          <div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input
                matInput
                placeholder="********"
                formControlName="password2"
                type="password" />
              <mat-error
                *ngIf="
                  registerForm.controls.values.controls.password2.hasError(
                    'required'
                  )
                ">
                {{ 'Jelszó megadása kötelező!' | translate }}
              </mat-error>
              <mat-error
                *ngIf="
                  registerForm.controls.values.controls.password2.hasError(
                    'controlEquals'
                  )
                ">
                {{ 'Jelszavak nem megegyezőek!' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div></div>
        </div>
        <h3 class="required">{{ 'Adj nevet a profilodnak' | translate }}</h3>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="avatar_name" />
          <mat-error
            *ngIf="
              registerForm.controls.values.controls.avatar_name.hasError(
                'required'
              )
            ">
            {{ 'Profilnév megadása kötelező!' | translate }}
          </mat-error>
          <!-- <mat-hint>{{
            'Írd be kutyád nevét (pl. Buksi), több kutya esetén falkanevet (pl. Plüssmacik) vagy a kenneled nevét (pl. Hógolyó Kennel)'
              | translate
          }}</mat-hint> -->
          <mat-hint>
            <span>{{ 'Profilneved legyen:' | translate }}</span>
            <ul class="hint-list">
              <li>{{ 'a kutyád neve (pl.: Hulk)' | translate }}</li>
              <li>
                {{
                  'amennyiben több kutyád van, akkor sorolj itt fel max. hármat, vagy adj fantázianevet falkádnak'
                    | translate
                }}
              </li>
              <li>
                {{
                  'ha tenyésztő vagy, akkor a kennel neved (pl. Dancing Rock Kennel).'
                    | translate
                }}
              </li>
            </ul>
          </mat-hint>
        </mat-form-field>
        <h3 class="required">{{ 'Profilkép' | translate }}</h3>
        <div class="profile-image-form">
          <div
            class="profile-image-form-content"
            [ngClass]="{ mobile: isMobile() }">
            <app-image-cropper
              (imageChanged)="updateImage($event, registerForm.controls.avatar)"
              [resizeToHeight]="290"
              [resizeToWidth]="290"
              [isAvatarCropper]="true"></app-image-cropper>
            <div class="info-text">
              <p>
                <strong>{{
                  'Tölts fel 1 db képet kutyádról vagy kutyáidról.' | translate
                }}</strong>
              </p>
              <ul>
                <li>
                  {{ 'Elfogadott fájlformátumok: JPG, PNG, WEBP' | translate }}
                </li>
                <li>
                  {{
                    'A feltöltött képet automatikusan négyzet formára méretezzük'
                      | translate
                  }}
                </li>
              </ul>
            </div>
          </div>
          <div
            *ngIf="
              registerForm.controls.avatar.touched &&
              registerForm.controls.avatar.hasError('requiredBlobFile')
            ">
            <mat-error>
              {{ 'Profilkép megadása kötelező!' | translate }}
            </mat-error>
          </div>
        </div>
        <h3 class="required">{{ 'Lakóhely' | translate }}</h3>
        <div class="two-input-row" [ngClass]="{ mobile: isMobile() }">
          <app-country-picker
            [formGroup]="registerForm.controls.values"
            formKey="country"
            [selectedCountryName]="
              cityPicker.selectedCity()?.country
            "></app-country-picker>
          <app-city-picker
            #cityPicker
            [formGroup]="registerForm.controls.values"
            formKey="city"
            [countryCode]="
              registerForm.value.values?.country
            "></app-city-picker>
        </div>
        <h3>{{ 'Gazdi neve' | translate }}</h3>
        <mat-form-field appearance="outline">
          <input matInput formControlName="name" />
        </mat-form-field>
      </section>
      <section
        class="alt-color-bg"
        formGroupName="dog_values"
        [ngClass]="{ mobile: isMobile() }">
        <div class="max-width">
          <h2>{{ 'Kutyád adatai' | translate }}</h2>
          <div>
            {{
              'Ha több kutyád vagy kenneled van, töltsd ki az adatokat az egyik kutyádra vonatkozóan, majd a regisztráció megerősítése után a Profilban +kutya hozzáadásával felveheted többi kedvencedet is.'
                | translate
            }}
          </div>
          <h3 class="required">{{ 'Kutya neve' | translate }}</h3>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="name" />
            <mat-error
              *ngIf="
                registerForm.controls.dog_values.controls.name.hasError(
                  'required'
                )
              ">
              {{ 'Kutya nevének megadása kötelező!' | translate }}
            </mat-error>
          </mat-form-field>
          <h3>{{ 'Törzskönyvi neve' | translate }}</h3>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput formControlName="registered_name" />
          </mat-form-field>
          <h3 class="required">{{ 'Fajtája' | translate }}</h3>
          <app-dog-breed-picker
            formKey="breed_id"
            [formGroup]="registerForm.controls.dog_values">
          </app-dog-breed-picker>
          <mat-checkbox
            formControlName="mixed"
            (change)="changeMixedCheckbox($event)"
            aria-label="Dog is mixed checkbox"
            id="mixed-input"
            >{{ 'Keverék' | translate }}</mat-checkbox
          >
          <h3 class="required">{{ 'Ivara' | translate }}</h3>
          <mat-radio-group
            aria-label="Dog's gender radio buttons"
            formControlName="gender_neuter">
            <mat-radio-button [value]="0">{{
              'ivaros kan' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="1">{{
              'ivartalanított kan' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="2">{{
              'ivaros szuka' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="3">{{
              'ivartalanított szuka' | translate
            }}</mat-radio-button>
          </mat-radio-group>
          <mat-error
            *ngIf="
              registerForm.controls.dog_values.controls.gender_neuter.touched &&
              registerForm.controls.dog_values.controls.gender_neuter.hasError(
                'required'
              )
            ">
            {{ 'Ivar megadása kötelező!' | translate }}
          </mat-error>
          <!-- <mat-error
            *ngIf="
              registerForm.controls.dog_values.controls.female.hasError(
                'required'
              ) && registerForm.controls.dog_values.controls.female.touched
            ">
            {{ 'Mező kiválasztása kötelező!' | translate }}
          </mat-error>
          <mat-radio-group
            aria-label="Is dog neutered radio buttons"
            formControlName="neutered">
            <mat-radio-button [value]="false">{{
              'ivaros' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="true">{{
              'ivartalanított' | translate
            }}</mat-radio-button>
          </mat-radio-group>
          <mat-error
            *ngIf="
              registerForm.controls.dog_values.controls.neutered.hasError(
                'required'
              ) && registerForm.controls.dog_values.controls.neutered.touched
            ">
            {{ 'Mező kiválasztása kötelező!' | translate }}
          </mat-error> -->
          <h3>{{ 'Kutya születési dátuma' | translate }}</h3>
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <mat-label>{{
              'A dátum kiválasztásához kattints a naptár ikonra!' | translate
            }}</mat-label>
            <input
              matInput
              formControlName="birthday"
              [matDatepicker]="picker"
              [matDatepickerFilter]="futureFilter"
              readonly />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error
              *ngIf="
                registerForm.controls.dog_values.controls.birthday.hasError(
                  'required'
                )
              ">
              {{ 'Kutya születési dátumának megadása kötelező!' | translate }}
            </mat-error>
          </mat-form-field>
          <h3 class="required">{{ 'Kutya profilkép' | translate }}</h3>
          <div class="profile-image-form">
            <div
              class="profile-image-form-content"
              [ngClass]="{ mobile: isMobile() }">
              <app-image-cropper
                (imageChanged)="
                  updateImage($event, registerForm.controls.dog_avatar)
                "
                [resizeToHeight]="400"
                [resizeToWidth]="400"
                [isAvatarCropper]="false"></app-image-cropper>
              <div class="info-text">
                <p>
                  <strong>{{
                    'Tölts fel 1 db képet kutyádról.' | translate
                  }}</strong>
                </p>
                <ul>
                  <li>
                    {{
                      'Elfogadott fájlformátumok: JPG, PNG, WEBP' | translate
                    }}
                  </li>
                  <li>
                    {{
                      'A feltöltött képet automatikusan négyzet formára méretezzük'
                        | translate
                    }}
                  </li>
                </ul>
              </div>
            </div>
            <div
              *ngIf="
                registerForm.controls.dog_avatar.touched &&
                registerForm.controls.dog_avatar.hasError('requiredBlobFile')
              ">
              <mat-error>
                {{ 'Kutya profilkép megadása kötelező!' | translate }}
              </mat-error>
            </div>
          </div>
        </div>
      </section>
      <div class="accept-row">
        <ul class="invisible-list">
          <li>
            <mat-checkbox formControlName="termsOfService"
              ><span
                *ngIf="termsOfServiceTranslateParams"
                [innerHTML]="
                  'Elfogadom az Oldalhasználati feltételeket és az Adatkezelési tájékoztatót'
                    | translate: termsOfServiceTranslateParams
                ">
              </span>
              <span class="required" style="font-size: large"></span>
            </mat-checkbox>
            <div
              *ngIf="
                registerForm.controls.termsOfService.touched &&
                registerForm.controls.termsOfService.hasError('required')
              "
              class="mat-error-terms-req-cont tos-error-box mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align">
              <div class="mat-mdc-form-field-error-wrapper">
                <mat-error class="mat-error">
                  {{ 'Feltételek elfogadása kötelező!' | translate }}
                </mat-error>
              </div>
            </div>
          </li>
          <li>
            <mat-checkbox
              [formControl]="registerForm.controls.values.controls.newsletter"
              ><div style="max-width: 500px">
                {{
                  'Szeretnék feliratkozni a GloboDog hírlevélre, hogy időben értesüljek a legfrissebb hírekről, eseményekről.'
                    | translate
                }}
              </div></mat-checkbox
            >
          </li>
        </ul>
      </div>
      <div class="button-container">
        <button
          *ngIf="!registerPending"
          mat-flat-button
          color="primary"
          type="submit">
          {{ 'Regisztrálok' | translate }}
        </button>
        <button
          *ngIf="registerPending"
          mat-flat-button
          color="primary"
          disabled>
          <mat-spinner [diameter]="24"></mat-spinner>
        </button>
        <a mat-button [routerLink]="['/', lang, 'login']">{{
          'Vissza a bejelentkezéshez' | translate
        }}</a>
      </div>
    </form>
  </div>
</div>
